import { createContext } from 'react'
import type { Predication } from '@/types/Predication'
import type { MembreEquipe } from '@/types/MembreEquipe'
import type { Contact, Dons, MotDuPasteur, SiteContent } from '@/types/Contenu'

export type EtatContenu = 'chargement' | 'pret' | 'erreur'

export interface ContentContextValue extends SiteContent {
  /** Chargement du contenu à jour. En attendant, le contenu affiché vient du cache ou du build. */
  etatContenu: EtatContenu
  erreurContenu: string | null
  /**
   * Vrai tant que le contenu affiché est celui du build (premier passage, serveur pas encore
   * répondu) : à ne pas présenter comme fiable (ex. numéros de dons).
   */
  contenuProvisoire: boolean
  rechargerContenu: () => Promise<void>
  /** Renvoie la prédication enregistrée (avec son id/slug définitif). */
  savePredication: (predication: Predication) => Promise<Predication>
  deletePredication: (id: string) => Promise<void>
  /** Renvoie le membre enregistré (avec son id définitif). */
  saveMembre: (membre: MembreEquipe) => Promise<MembreEquipe>
  deleteMembre: (id: string) => Promise<void>
  moveMembre: (id: string, direction: -1 | 1) => Promise<void>
  saveMotDuPasteur: (mot: MotDuPasteur) => Promise<void>
  saveDons: (dons: Dons) => Promise<void>
  saveContact: (contact: Contact) => Promise<void>
  reset: () => Promise<void>
}

export const ContentContext = createContext<ContentContextValue | null>(null)
